<template>
	<div class="statistics">
		<div class='container'>

			<div
				class='upper'
				v-if='title || description || parsedCta'
			>
				<h2
					v-if="title"
					v-html="title"
				></h2>
				<div
					class="description"
					v-if="description"
					v-html="description"
				></div>
				<div
					class='cta_container'
					v-if='parsedCta'
				>
					<secondary-button
						:label="parsedCta.title"
						:link="parsedCta"
						theme='reverse'
					></secondary-button>
				</div>
			</div>

			<div
				class='statistic'
				:class='statisticCount'
				v-for="(statistic, index) in parsedStatistics"
				:key='index'
			>
				<div
					class='icon_statistic'
					v-if="statistic.icon || statistic.statistic"
				>
					<img
						v-if="statistic.icon_or_statistic === 'icon' && statistic.icon"
						:src="statistic.icon.url"
						:alt="statistic.title"
					/>
					<h1
						v-if="statistic.icon_or_statistic === 'statistic' && statistic.statistic != ''"
						v-html="statistic.statistic"
					></h1>
				</div>
				<div class='content'>
					<h4
						v-if="statistic.title"
						v-html="statistic.title"
					></h4>
					<div
						class="description"
						v-if="statistic.description"
						v-html="statistic.description"
					></div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import SecondaryButton from './SecondaryButton.vue';
export default {
	props: {
		title: {},
		description: {},
		statistics: {},
		call_to_action: {},
	},

	computed: {
		parsedStatistics() {
			if (this.statistics) {
				return JSON.parse(this.statistics);
			} else {
				return null;
			}
		},

		parsedCta() {
			if (this.call_to_action) {
				return JSON.parse(this.call_to_action);
			} else {
				return null;
			}
		},

		statisticCount() {
			if (this.parsedStatistics.length === 1) {
				return 'one';
			} else if (this.parsedStatistics.length === 2) {
				return 'two';
			} else if (this.parsedStatistics.length === 3) {
				return 'three';
			} else {
				return 'four';
			}
		},
	},

	watch: {},

	methods: {},

	components: { SecondaryButton },

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.statistics {
	background: var(--midnight);
	padding: 50px 0;

	.container {
		.upper {
			grid-column: span 12;
			margin-bottom: 67px;

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
				margin-bottom: 40px;
			}

			h2 {
				color: var(--cobalt);
				margin: 0 auto 24px;
				text-align: center;

				@media (max-width: $mobile-xl) {
					text-align: left;
				}
			}

			.description {
				color: var(--white);
				max-width: 600px;
				margin: 0 auto 40px;
				text-align: center;

				@media (max-width: $mobile-xl) {
					text-align: left;
				}

				p {
					color: var(--white);
				}

				&::v-deep {
					p {
						/* font: normal normal normal 14px/20px var(--primary-font-family); */
						color: var(--white);
					}
				}
			}

			.cta_container {
				margin-top: 48px;
				/* z-index: 10; */
				/* max-width: calc(100% - calc(113px - 54px)); */
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				gap: 24px;
				min-width: 100%;
				justify-content: center;

				@media (max-width: $mobile-xl) {
					margin-top: (32px - 16px);
					text-align: left;
					display: flex;
					flex-wrap: wrap;
					gap: var(--spacer-mobile);
					justify-content: flex-start;
				}
			}
		}

		.statistic {
			grid-column: span 3;
			display: flex;
			flex-direction: column;
			flex-wrap: wrap;
			gap: 24px;
			padding: 0;

			&.one {
				grid-column: span 12;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
				}
			}

			&.two {
				grid-column: span 6;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
				}
			}

			&.three {
				grid-column: span 4;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
				}
			}

			&.four {
				grid-column: span 3;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
				}
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
				padding: 16px 0;
				border-top: var(--border-blue);
				border-left: unset;
			}

			.icon_statistic {
				display: flex;
				flex-direction: column;
				flex-wrap: wrap;
				min-height: 56px;

				@media (max-width: $mobile-xl) {
					min-height: unset;
				}

				img {
					height: 56px;
					width: 56px;
					display: flex;
				}

				h1 {
					color: var(--cobalt);
					margin: 0;
				}
			}

			.content {
				display: flex;
				flex-direction: column;
				gap: 24px;

				h4 {
					color: var(--white);
					margin: 0;
				}

				.description {
					color: var(--white);
					margin-top: 0;

					p {
						color: var(--white);
					}

					&::v-deep {
						p {
							font: normal normal normal 14px/20px var(--primary-font-family);
							color: var(--white);
						}
					}
				}
			}
		}
	}
}
</style>
